import {
  useNavigateWithPersistParams,
  useReselector,
} from '@/utils/sharedHooks'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'
import { SIGNUP_PATHS } from '../helpers'
import { TypographyStyles } from '@/styles'
import { Text } from '@/ui'
import { SignupPageLayout } from '../SignupPageLayout'
import { SignupFooter } from '../SignupFooter'

export const Disqualified = () => {
  const navigate = useNavigateWithPersistParams()
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)

  const nextPage = SIGNUP_PATHS.payment
  const previousPage = SIGNUP_PATHS.choosePlan

  return (
    <SignupPageLayout
      footer={
        <SignupFooter
          onBack={() => navigate(previousPage)}
          onContinue={() => navigate(nextPage)}
          continueId="btn-signup-previous-year-form"
        />
      }
    >
      <div className="flex flex-col space-y-4">
        <Text variant={TypographyStyles.BODY_LG} className="mb-4">
          <b>
            We&apos;re working hard to prepare for this year&apos;s tax season.
          </b>
        </Text>

        <Text className="mb-4">
          Helping you file your taxes for this year (
          {Number(currentTaxYear) + 1}) is part of your plan.
        </Text>

        <Text className="mb-4">
          However, we are unable to help you file your taxes for last year (
          {currentTaxYear}). If you still need help with your {currentTaxYear}{' '}
          taxes, we recommend seeking assistance outside of Heard.
        </Text>
      </div>
    </SignupPageLayout>
  )
}
